import { useNotification } from '@gohighlevel/ghl-ui'
import { AxiosError, isAxiosError } from 'axios'
import { computed, inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { LocationServices, TemplateType } from '../services'
import { getTranslatedErrorMessage } from '../utils/errorCodeMapper'

const loadingSmsTemplates = ref(false)
const smsTemplates: any = ref([])

export const useSMSTemplates = () => {
  const { t } = useI18n()
  const route = inject<any>('route')
  const notification = useNotification()

  const smsTemplateOptions = computed(() => {
    const options = smsTemplates?.value?.map((p: any) => ({
      label: p.name,
      value: p.id,
    }))
    options.unshift({
      label: t('common.default'),
      value: 'default',
    })
    return options
  })

  const getSMSTemplates = async (params: { locationId?: string }) => {
    try {
      loadingSmsTemplates.value = true
      const locationId = params?.locationId || route?.params?.location_id
      if (!locationId) return
      const { data } = await LocationServices.getTemplatesForLocationAndType(
        locationId,
        TemplateType.SMS
      )
      smsTemplates.value = data?.templates
    } catch (error: any) {
      let errorMsg = t('validations.invalid.listSMSTemplates')
      if (isAxiosError(error)) {
        const axiosError = error as AxiosError
        if (axiosError.response) {
          errorMsg = getTranslatedErrorMessage(axiosError, t, errorMsg)
        } else if (error?.message) {
          errorMsg = error.message
        }
      } else if (error?.message) {
        errorMsg = error.message
      }
      if (Array.isArray(errorMsg)) errorMsg = errorMsg.join(', ')
      notification.error({
        content: errorMsg,
        duration: 3000,
        keepAliveOnHover: true,
      })
    } finally {
      loadingSmsTemplates.value = false
    }
  }

  return {
    smsTemplateOptions,
    loadingSmsTemplates,
    smsTemplates,
    getSMSTemplates,
  }
}
